const mapProviderToPathSegment = provider =>
  provider === 'google' && process.env.NODE_ENV === 'development'
    ? 'github'
    : provider

export default provider => {
  const queryParams = new URLSearchParams()
  const currentQueryString = window.location.search.substring(1)
  const providerSegment = mapProviderToPathSegment(provider)

  queryParams.set('client_id', process.env.REACT_APP_CLIENT_ID)
  queryParams.set('redirect_uri', process.env.REACT_APP_SSO_REDIRECT_URI)

  if (currentQueryString) {
    queryParams.set('passthrough_params', JSON.stringify(currentQueryString))
  }

  return `${
    process.env.REACT_APP_API_HOST
  }/sso/${providerSegment}/init?${queryParams}`
}



// WEBPACK FOOTER //
// ./src/utils/urlForProvider.js